import { boolean, object, string, number } from 'yup'

import { stringify } from 'src/core/hooks/use-translation'

export const Partner = object().shape({
  additional_info: string().required(),
  address_number: string().required(),
  address: string().required(),
  city_id: string().required(),
  country_id: string().required(),
  partner_description: string()
    .max(
      50,
      stringify('web.setup.form.field-title.max-character-error', { value: 50 })
    )
    .required(),
  partner_name: string()
    .trim()
    .max(
      50,
      stringify('web.setup.form.field-title.max-character-error', { value: 50 })
    )
    .required(),
  partner_vat_number: number().required().typeError('common.required_number'),
  quarter: string()
    .max(
      30,
      stringify('web.setup.form.field-title.max-character-error', { value: 30 })
    )
    .required(),
  state_id: string().required(),
  zip_code: string()
    .max(
      9,
      stringify('web.setup.form.field-title.max-character-error', { value: 9 })
    )
    .min(
      8,
      stringify('web.setup.form.field-title.min-character-error', { value: 8 })
    )
    .required()
})

export const Hotel = object().shape({
  category_stars: number().required(),
  hotel_class: string().required(),
  hotel_image_url: string().required(),
  information: string().required(),
  laundry: boolean().required(),
  nights: number().required(),
  parking: boolean().required(),
  pool: boolean().required(),
  refundable: boolean().required(),
  restaurant: boolean().required()
})
